import i18n from '@/i18n'
// 2026-09-17：兼容生产商等分店的历史菜单键，仅映射显示文案，不改权限键或路由。
const routeTitleAliases = new Map<string, string>([
  ['platforminfo', 'platform.platforminfo'],
  ['accounts', 'platform.accounts'],
  ['platform.myaccount', 'financial.myaccount'],
  ['financial.withdraw', 'financial.withdrawal']
])
// 2026-07-23 15:30：翻译键不存在时回退原始文案，避免界面和操作日志出现 msg.route.*。
export const generateTitle = (title: any, fallbackTitle?: any): string => {
  const originalTitle = title == null ? '' : String(title)
  const translationKey = 'msg.route.' + (routeTitleAliases.get(originalTitle) || originalTitle)
  if (originalTitle && i18n.global.te(translationKey)) return i18n.global.t(translationKey)
  // 2026-09-17：动态菜单缺少词条时使用接口中的名称，避免向用户显示英文功能标识。
  const fallbackName = fallbackTitle == null ? '' : String(fallbackTitle)
  return fallbackName.trim() ? fallbackName : originalTitle
}
